import { Hourglass } from 'lucide-react';
import React from 'react';
import { EmptyState } from '../components/EmptyState';
import { SectionCard } from '../components/SectionCard';

type ComingSoonPageProps = {
  label: string;
  title: string;
  description: string;
  planned: string[];
};

function ComingSoonPage({ label, title, description, planned }: ComingSoonPageProps) {
  return (
    <SectionCard label={label} title={title} description={description}>
      <EmptyState
        icon={<Hourglass size={22} />}
        title="This feature is not yet available"
        description="It is on the roadmap. Here is what it will include when it ships:"
      />
      <ul className="comingSoonList" style={{ margin: '0.75rem 1.25rem 1rem', paddingLeft: '1.25rem', display: 'grid', gap: '0.35rem', color: 'var(--color-text-muted, #6b7280)', fontSize: '0.875rem' }}>
        {planned.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </SectionCard>
  );
}

export { ComingSoonPage };
